var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Utils } from '@pacem/pacem-core';
import { StalePropertyFlag } from './types';
import { NotifyChange } from './decorators';
export class NodeGeometry {
    constructor(positions = []) {
        this.positions = positions;
    }
    static barycenter(positions) {
        var bary = { x: 0, y: 0, z: 0 };
        if (!Utils.isNullOrEmpty(positions)) {
            var count = positions.length;
            for (var i = 0; i < positions.length; i++) {
                var pt = positions[i];
                bary.x += pt.x;
                bary.y += pt.y;
                bary.z += pt.z;
            }
            var countDbl = 1.0 * count;
            bary.x /= countDbl;
            bary.y /= countDbl;
            bary.z /= countDbl;
        }
        return bary;
    }
    static boundingBox(positions) {
        const output = {
            minX: +Infinity, minY: +Infinity, minZ: +Infinity,
            maxX: -Infinity, maxY: -Infinity, maxZ: -Infinity
        };
        if (!Utils.isNullOrEmpty(positions)) {
            for (var i = 0; i < positions.length; i++) {
                var pt = positions[i];
                output.minX = Math.min(output.minX, pt.x);
                output.minY = Math.min(output.minY, pt.y);
                output.minZ = Math.min(output.minZ, pt.z);
                output.maxX = Math.max(output.maxX, pt.x);
                output.maxY = Math.max(output.maxY, pt.y);
                output.maxZ = Math.max(output.maxZ, pt.z);
            }
        }
        return output;
    }
    setAsDirty() {
        setSelfAsDirty.call(this);
    }
}
function setSelfAsDirty() {
    const me = this;
    me.flags = [/* no further specifications, other than 'geometry' */ StalePropertyFlag.Geometry];
}
export class LineGeometry extends NodeGeometry {
}
__decorate([
    NotifyChange(setSelfAsDirty)
], LineGeometry.prototype, "positions", void 0);
export class MeshGeometry extends NodeGeometry {
    #boundingBox;
    #boundingSphere;
    #barycenter;
    get barycenter() {
        return this.#barycenter ??= NodeGeometry.barycenter(this.positions);
    }
    set barycenter(point) {
        this.#barycenter = point;
    }
    get boundingBox() {
        return this.#boundingBox ??= NodeGeometry.boundingBox(this.positions);
    }
    set boundingBox(bbox) {
        this.#boundingBox = bbox;
    }
    get boundingSphere() {
        return this.#boundingSphere;
    }
    set boundingSphere(sphere) {
        this.#boundingSphere = sphere;
    }
    constructor(positions, triangleIndices, textureCoordinates = [], normals = []) {
        super(positions);
        this.triangleIndices = triangleIndices;
        this.textureCoordinates = textureCoordinates;
        this.normals = normals;
    }
}
__decorate([
    NotifyChange(setSelfAsDirty)
], MeshGeometry.prototype, "positions", void 0);
__decorate([
    NotifyChange(setSelfAsDirty)
], MeshGeometry.prototype, "triangleIndices", void 0);
__decorate([
    NotifyChange(setSelfAsDirty)
], MeshGeometry.prototype, "textureCoordinates", void 0);
__decorate([
    NotifyChange(setSelfAsDirty)
], MeshGeometry.prototype, "normals", void 0);
